<template>
<!-- 按货位盘点 -->
  <div>
    <!-- 基础信息 S -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="color:#222;font-weight:600">基础信息</span>
      </div>
      <el-form :model="planFrom" label-width="160px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="盘点计划编号：" >
              {{planFrom.yipCode}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="盘点类型：" >
              <div v-for="item in liquidationType" :key="item.value">
                <span v-if="item.value==type">{{item.label}}</span>
              </div>
            </el-form-item>
          </el-col>
           <el-col :span="8">
            <el-form-item label="状态：" >
              <div v-for="item in liquidationState" :key="item.value">
                <span v-if="item.value==planFrom.taskState">{{item.label}}</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="this.type!=2">
          <el-col :span="8">
            <el-form-item label="供应商：" >
              {{planFrom.ysName}}
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="this.type==0">
            <el-form-item label="盘点库区：" >
              {{planFrom.yaName}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="创建人：" >
              {{planFrom.createName}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建时间：" >
              {{planFrom.createTime}}
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </el-card>
    <!-- 基础信息 E -->
    <!-- 盘点明细 S -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="color:#222;font-weight:600">盘点明细</span>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="货位详情" name="loaction"  v-if="this.type==2"></el-tab-pane>
        <el-tab-pane label="商品详情" name="goods" v-else></el-tab-pane>
      </el-tabs>
      <!-- 列表 S -->
    <page-table ref='pageTable'
                :list="planDetail"
                :fieldList="tableFieldList"
                handelWidth='120'
                >
    </page-table>
    </el-card>
    <!-- 盘点明细 E -->

  </div>
</template>
<script>
import liquidationManage from '@/store/liquidationManage/index'
import { GETPLANDETAIL } from '@/store/liquidationManage/types'
import pageTable from '@/components/Table/Index'

export default{
  components: {
    pageTable
  },
  data () {
    return {
      type: null,
      activeName: 'goods',
      liquidationType: [
        {value: 1, label: '按商品总数盘点'},
        {value: 0, label: '按商品货位盘点'},
        {value: 2, label: '按货位盘点'}
      ] // 盘点类型
    }
  },
  computed: {
    // 商品信息
    planDetail () {
      return {rows: liquidationManage.state.planDetail.list}
    },
    planFrom () {
      return liquidationManage.state.planDetail.basis
    },
    tableFieldList () {
      if (this.type === '2') {
        return [
          { label: '库区', prop: 'yaName', width: 160, align: 'center' },
          { label: '货位编码', prop: 'ylCode', align: 'center' }
        ]
      } else {
        return [
          { label: '商品名称', prop: 'ygName', align: 'center' },
          { label: '商品属性', prop: 'bdName', width: 160, align: 'center' },
          { label: '规格', prop: 'standard', width: 160, align: 'center' },
          { label: '箱规（件/箱）', prop: 'box', width: 160, align: 'center' },
          { label: '商品编码', prop: 'goodsCode', width: 160, align: 'center' },
          { label: '商品条码', prop: 'barCode', width: 160, align: 'center' }
        ]
      }
    },
    // 盘点状态
    liquidationState () {
      return [
        {value: 0, label: '待盘点'},
        {value: 1, label: '盘点中'},
        {value: 2, label: '盘点完成'},
        {value: 3, label: '已取消'}
      ]
    }
  },
  mounted () {
    this.type = this.$route.params.type

    if (this.type === 2) this.activeName = 'loaction'

    let params = {
      yipType: this.$route.params.type,
      yipCode: this.$route.params.code
    }
    this.$store.dispatch(GETPLANDETAIL, params)
  },
  methods: {

  }
}
</script>
<style scoped>
 .submit-btn {
   margin:10px 20px 10px;
   float: right;
  }
</style>



// WEBPACK FOOTER //
// src/page/liquidationManage/liquidationPlanDetail.vue